import { render, staticRenderFns } from "./TabPane.vue?vue&type=template&id=1828497a&scoped=true&"
import script from "./TabPane.vue?vue&type=script&lang=js&"
export * from "./TabPane.vue?vue&type=script&lang=js&"
import style0 from "./TabPane.vue?vue&type=style&index=0&id=1828497a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1828497a",
  null
  
)

export default component.exports